import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// importar componentes, para declararlos
  // Login
  import Login from './Login/Login';
  import LoginResetPassword from './Login/LoginResetPassword';
  import Home from './Home/Home'; 
  // Usuarios
  import Usuarios from './Usuarios/Usuarios'
  import NuevoUsuario from './Usuarios/Nuevo_Usuario'
  import ActualizarUsuario from './Usuarios/Actualizar_Usuario'
  // Bitacoras
  import Bitacoras from './Bitacoras/Bitacoras'
  import BitacoraNuevaSeguimiento from './Bitacoras/BitacoraNueva_Seguimiento'
  import Bitacora_Seguimiento from './Bitacoras/Bitacora_Seguimiento'
  //Incidencias
  import Incidencias from './Incidencias/Incidencias';
  import IncidenciaNueva from './Incidencias/IncidenciaNueva';
  import Incidencia_Seguimiento from './Incidencias/Incidencia_Seguimiento';

function App() {
  return (
    <Router>
      <Routes>
        {/* Login */}
          <Route path="/" element={<Login />} />Bitacora_Seguimiento
          <Route path="/reset-password" element={<LoginResetPassword />} />
          <Route path="/home" element={<Home />} />
        {/* Usuarios */}
          <Route path="/Usuarios" element={<Usuarios />} />
          <Route path="/Nuevo_Usuario" element={<NuevoUsuario />} />
          <Route path="/Actualizar_Usuario/:idUsuario" element={<ActualizarUsuario />} />
        {/* Bitacoras */}
          <Route path="/Bitacoras" element={<Bitacoras />} />
          <Route path="/BitacoraNueva_Seguimiento" element={<BitacoraNuevaSeguimiento />} />
          <Route path="/Bitacora_Seguimiento/:idBitacora" element={<Bitacora_Seguimiento />} />
        {/*Incidencias*/}
          <Route path='/Incidencias' element={<Incidencias/>} />
          <Route path='/IncidenciaNueva' element={<IncidenciaNueva/>} />
          <Route path='/Incidencia_Seguimiento/:idIncidencia' element={<Incidencia_Seguimiento/>} />
      </Routes>
    </Router>
  );
} 

export default App;
